import { render, staticRenderFns } from "./Milestones.vue?vue&type=template&id=f018b2ea&scoped=true"
import script from "./Milestones.vue?vue&type=script&lang=ts"
export * from "./Milestones.vue?vue&type=script&lang=ts"
import style0 from "./Milestones.vue?vue&type=style&index=0&id=f018b2ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f018b2ea",
  null
  
)

export default component.exports